module.exports = __webpack_public_path__ + "media/images/vector-88@2x-8a25cf94ca9015a7e803eef76510687b.png";